import ExecAPI from 'appRoot/api/api';

export function PasskeyRegisterChallenge(isAtLogin)
{
	return ExecAPI("PasskeyCreate/PasskeyRegisterChallenge", { isAtLogin });
}
/**
 * Registers a newly created passkey.
 * @param {String} challenge Base64URL-encoded challenge from PasskeyRegisterChallenge.
 * @param {Object} attestationResponse The new credential in server format.
 * @param {String} deviceDescription Description of where the passkey was created (e.g. "Chrome on Android"), used as its name if the server does not know its provider.
 * @returns {Promise} Promise that delivers { id, name }: the new passkey's ID and the name it was given (null if unnamed).
 */
export function PasskeyRegister(challenge, attestationResponse, deviceDescription)
{
	return ExecAPI("PasskeyCreate/PasskeyRegister", { challenge, attestationResponse, deviceDescription });
}
export function PasskeyLoginChallenge(user)
{
	return ExecAPI("PasskeyAuth/PasskeyLoginChallenge", { user });
}
export function PasskeyLogin(challenge, assertionResponse)
{
	return ExecAPI("PasskeyAuth/PasskeyLogin", { challenge, assertionResponse });
}